import React, { Component } from 'react';
import "./style.scss";

// imports components
import TopNavbar from "../Topnavbar";
import MainCarousel from "../Carousel";
import Content from "../HomeContent";

class Home extends Component {
    render() {
        return (
            <div className="Home-container">
                <TopNavbar />
                <MainCarousel />
                <Content />
            </div>
        );
    }
}

export default Home;